(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('MoneyTransferLogDeleteController', MoneyTransferLogDeleteController);

    MoneyTransferLogDeleteController.$inject = ['$uibModalInstance', 'entity', 'MoneyTransferLog'];

    function MoneyTransferLogDeleteController($uibModalInstance, entity, MoneyTransferLog) {
        var vm = this;

        vm.moneyTransferLog = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            MoneyTransferLog.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
